import React from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';

const MobileNavigationItem = ({
  link,
  name,
  url,
  onLinkClick,
  className,
  icon,
}) => {
  return (
    <li className={clsx('navigation-mobile__list-item', className)}>
      {onLinkClick && link && link.links?.length > 0 ? (
        <button
          className="navigation-mobile__button"
          onClick={() => onLinkClick(link)}
        >
          {name}
          <Icon
            className="navigation-mobile__right-icon"
            name="Caret-Right"
            size={24}
          />
        </button>
      ) : (
        <a className="navigation-mobile__link" href={url}>
          {icon && (
            <Icon
              className="navigation-mobile__link-icon"
              name={icon}
              size={24}
            />
          )}
          {name}
        </a>
      )}
    </li>
  );
};
export default MobileNavigationItem;
